import React from 'react';
import PropTypes from 'prop-types';
import { map, upperFirst } from 'lodash';

import { labelHour } from 'utils/time';
import './AccessHours.scss';

export function AccessHours({ accessHours, officeHours }) {
	const formatHours = (hoursObj) => {
		if (!hoursObj) return [];

		const data = map(hoursObj, (hour, key) => ({
			label: upperFirst(String(key)),
			hoursStr: upperFirst(labelHour(hour)),
		}));
		return data;
	};

	const renderHoursTable = (hours, title) => {
		if (!hours) return null;

		const formattedHours = formatHours(hours);

		return (
			<div>
				<div className="facility-v2-access-hours-title">{title}</div>
				<table>
					<tbody>
						{map(formattedHours, (hour) => (
							<tr key={hour.label}>
								<th>{hour.label}</th>
								<td>{hour.hoursStr}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	};

	return (
		<div className="facility-v2-access-hours">
			{renderHoursTable(officeHours, 'OFFICE HOURS')}
			{renderHoursTable(accessHours, 'ACCESS HOURS')}
		</div>
	);
}

AccessHours.propTypes = {
	accessHours: PropTypes.object,
	officeHours: PropTypes.object,
};

export default AccessHours;
